import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/check mark.svg` */
export const CheckMarkIcon = createTripletGlyphIcon('CheckMarkIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.6557 3.26877C13.9171 2.98402 14.3601 2.96543 14.6449 3.22678C14.9297 3.48823 14.9484 3.93125 14.6869 4.21604L11.0063 8.22531L7.32559 12.2346C6.81103 12.7945 5.93863 12.8273 5.38321 12.3078L1.34903 8.5344C1.06715 8.27031 1.05304 7.82734 1.3168 7.54514C1.58091 7.26314 2.02383 7.24802 2.30606 7.51193L6.31582 11.2629L13.6557 3.26877Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.4274 3.89473C15.6888 3.60999 16.1319 3.59143 16.4166 3.85273C16.7014 4.11419 16.7201 4.55723 16.4586 4.84199L8.17738 13.8625C7.6314 14.4567 6.70521 14.4919 6.11586 13.9406L1.57777 9.69551C1.296 9.43151 1.28204 8.98846 1.54555 8.70625C1.80965 8.42424 2.25258 8.40914 2.53481 8.67305L7.07191 12.9182C7.09288 12.9377 7.12652 12.936 7.14613 12.9152L15.4274 3.89473Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.5937 5.21347C20.9307 4.84671 21.501 4.82213 21.8681 5.15878C22.2351 5.49582 22.2597 6.06704 21.9228 6.43417L10.8808 18.4615C10.1645 19.2417 8.94921 19.2884 8.17571 18.565L2.1259 12.9049C1.76193 12.5644 1.74243 11.9925 2.08293 11.6285C2.42343 11.2648 2.99444 11.2462 3.35832 11.5865L9.40911 17.2467C9.44981 17.2844 9.51309 17.2817 9.55071 17.2408L20.5937 5.21347Z"
        fill="currentColor"
      />
    </svg>
  ),
});
